import React from 'react';
import GetInvolvedHeader from '../components/ServicesComponents/GetInvolvedHeader';
import CallToAction from '../components/Misc/CallToAction';
import TextContent from '../components/TextContent/TextContent';
import Heading from '../components/Headers/Heading';
import ServiceBox from '../components/ServicesComponents/ServiceBox';
import { ServicesData } from '../Data/ServicesData';

function ServicesStyle1() {
    const admissionSteps = [
        'Step 1: Call or message our admissions team for a confidential conversation.',
        'Step 2: Share key medical and personal background details for assessment.',
        'Step 3: Complete eligibility and financial guidance with our support staff.',
        'Step 4: Confirm admission date, required documents, and arrival plan.',
        'Step 5: Arrive for intake, orientation, and immediate treatment planning.'
    ];

    return (
        <>
            <GetInvolvedHeader />
            <div className="services-section">
                <div className="services-section-wrapper">
                    <div className="container">
                        <Heading 
                            heading={<h1>Who Can Apply</h1>}
                            headingClass="heading-very-large dark-1"
                            headingColumn="col-lg-6"
                            paragraph="We welcome individuals seeking help for substance use, families seeking support for a loved one, and referrals from professionals or organizations."
                            paragraphClass="dark-2"
                            paragraphColumn="col-lg-6"
                        />
                        <div className="row service-withoutimage">
                            {[
                                { title: "Individuals seeking help", icon: ServicesData[0].icon },
                                { title: "Families seeking support", icon: ServicesData[1].icon },
                                { title: "Referrals from professionals", icon: ServicesData[2].icon },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <div className="col-lg-4">
                                        <ServiceBox title={item.title} icon={item.icon} />
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="projects">
                            <div className="projects-header-1" style={{ background: '#fff' }}>
                                <div className="container">
                                    <Heading 
                                        heading={<h2>Admission Steps</h2>}
                                        headingClass="heading-very-large dark-1"
                                        headingColumn="col-lg-9"
                                    />
                                </div>
                            </div>
                            <div className="projects-wrapper">
                                <div className="row justify-content-center">
                                    <div className="col-lg-10 col-xl-8">
                                        <ul className="paragraph dark-1" style={{ margin: 0, paddingLeft: '2rem' }}>
                                            {admissionSteps.map((step, index) => (
                                                <li key={index} style={{ marginBottom: '1.2rem' }}>
                                                    {step}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TextContent 
                headerTitle="Admissions & Intake" 
                footerHeading="Start your confidential admission process"
                primaryButtonText="Contact Admissions"
                primaryButtonLink="/contact"
                hideSecondaryButton={true}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default ServicesStyle1;
